import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToHash() {

  const location = useLocation();

  useEffect(() => {

    if (location.hash) {

      const element = document.getElementById(
        location.hash.replace("#", "")
      );

      if (element) {

        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 300);

      }

    }

  }, [location]);

  return null;
}

export default ScrollToHash;